<template>
  <div class="wrapper-calc">
    <div class="topbar row no-margin">
      <div
        :style="'font-size:' + fontSize + 'px'"
        class="display row no-margin col-8 align-items-center">
        <div
          :class="[{
            'text-danger': compare ? displayNumber < totalNumber : !isValid,
            'text-success': compare ? displayNumber >= totalNumber: isValid
          }]"
          class="col no-padding text-right font-weight-bold"
        >
          <span
            :class="[{ 'default-number': isDefaultShowNumber }]"
          >
            {{ displayNumber || '0' }}
          </span>
        </div>
      </div>
      <div class="delete col-4">
        <button
          :class="[{'active': btnActive == 'key-clear'}]"
          class="btn col key-clear"
          @click="clear()">
          <i class="fas fa-backspace"/>
        </button>
      </div>
    </div>
    <div class="outer-btn row no-margin">
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-1'}]"
          class="btn col key-1"
          @click="onPressButton('1', $event)">1</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-2'}]"
          class="btn col key-2"
          @click="onPressButton('2', $event)">2</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-3'}]"
          class="btn col key-3"
          @click="onPressButton('3', $event)">3</button>
      </div>
    </div>
    <div class="outer-btn row no-margin">
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-4'}]"
          class="btn col key-4"
          @click="onPressButton('4', $event)">4</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-5'}]"
          class="btn col key-5"
          @click="onPressButton('5', $event)">5</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-6'}]"
          class="btn col key-6"
          @click="onPressButton('6', $event)">6</button>
      </div>
    </div>
    <div class="outer-btn row no-margin">
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-7'}]"
          class="btn col key-7"
          @click="onPressButton('7', $event)">7</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-8'}]"
          class="btn col key-8"
          @click="onPressButton('8', $event)">8</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-9'}]"
          class="btn col key-9"
          @click="onPressButton('9', $event)">9</button>
      </div>
    </div>
    <div class="outer-btn row no-margin">
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-dot'}]"
          class="btn col key-dot"
          style="font-weight: bold;"
          @click="onPressButton('.', $event)">.</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{'active': btnActive == 'key-0'}]"
          class="btn col key-0"
          @click="onPressButton('0', $event)">0</button>
      </div>
      <div class="col-4 inner-btn">
        <button
          :class="[{
            'active': btnActive == 'key-enter',
            'btn-web': displayNumber >= totalNumber
          }]"
          :disabled="!isValid || disabled"
          class="btn col key-enter"
          @click="enter()">Enter</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const DEFAULT_FONT_SIZE = 46

export default {
  props: {
    // compare display number with total price
    compare: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      displayNumber: '',
      fontSize: DEFAULT_FONT_SIZE,
      btnActive: '',

      subTotalNumber: 0,
      discountNumber: 0,
      taxNumber: 0,
      totalNumber: 0,

      isUseKeyboardNumber: false,
      isUseKeyboardEnter: false,

      isDefaultShowNumber: true,
    }
  },
  computed: {
    ...mapGetters({
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // current table number selected
      getPosTotalPriceById: 'getPosTotalPriceById', // get total price from table number
      section: 'getPosSection',
    }),
    isValid () {
      if (!this.compare) {
        return this.displayNumber >= 0
      }
      return this.displayNumber !== '' && this.displayNumber >= this.totalNumber
    },
    isPaymentSection() {
      return this.section.current == 'payment'
    },
  },
  methods: {
    ...mapActions([

    ]),
    setUI () {
      let wrapperHeight = $('.wrapper-calc').outerHeight()
      $('.wrapper-calc .topbar, .wrapper-calc div.outer-btn').css({
        height: wrapperHeight / 5 + 'px',
      })
    },
    clear () {
      this.isDefaultShowNumber = false
      this.displayNumber = ''
      this.fontSize = DEFAULT_FONT_SIZE
    },
    enter () {
      const number = parseFloat(this.displayNumber) || 0
      const isValid = this.isValid
      const paymentMethod = 'cash'

      this.$emit('submit', isValid, number, paymentMethod, this.isUseKeyboardNumber, this.isUseKeyboardEnter)
    },
    onPressButton (number, event) {
      if (this.isDefaultShowNumber === true) {
        this.isDefaultShowNumber = false
        this.displayNumber = ''
      }

      this.displayNumber += number
      if (this.displayNumber.length > 12) {
        if (this.fontSize > 15) {
          this.fontSize -= 2
        }
      }
      if (event) {
        event.target.blur()
      }
    },
    handleKeyup (e) {
      let lastSecIsBarcode = this.$store.state.pos.pos.lastSecIsBarcode
      if (!lastSecIsBarcode) {
        var btnClass = ''
        if (e.key == 'Enter') {
          this.isUseKeyboardEnter = true
          if (this.isPaymentSection && this.displayNumber >= this.totalNumber) {
            btnClass += 'key-enter'
            this.enter()
          } else {
            btnClass += 'key-enter'
            this.enter()
          }
        }
        if (e.key == 'Backspace') {
          btnClass += 'key-clear'
          this.clear()
        }
        if (e.key == '.') {
          btnClass += 'key-dot'
          this.onPressButton('.')
        }
        if (parseInt(e.key) >= 0) {
          this.isUseKeyboardNumber = true
          let number = e.key
          btnClass += 'key-' + number
          this.onPressButton(number)
        }
        this.btnActive = btnClass
        setTimeout(() => {
          this.btnActive = ''
        }, 100)
      }
    },
  },
  watch: {

  },
  created: function () {
    let result = this.getPosTotalPriceById({
      queue_number: this.queue_number,
      table_number: this.table_number,
    }, this.mixin)
    this.subTotalNumber = result.sub
    this.discountNumber = result.discount
    this.taxNumber = result.tax
    this.totalNumber = result.total
    if (this.isPaymentSection) {
      this.displayNumber = `${result.total}`
    } else {
      this.displayNumber = '0'
    }
  },
  mounted: function () {
    this.setUI()

    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)
  },
  destroyed: function () {
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
  },
}
</script>
<style scoped>
  .wrapper-calc {
    width: 100%;
    height: 100%;
  }
  .wrapper-calc button.btn:focus {
    box-shadow: none;
  }
  .wrapper-calc .topbar .display {
    background: #FFF;
    border: solid 1px #D8E2E7;
    border-right: none;
    border-bottom: none;
    font-size: 46px;
    color: #383D44;
    position: relative;
    top: 2px;
  }
  .wrapper-calc .topbar, .wrapper-calc div.outer-btn {
    /* height: 100px; */
  }
  .wrapper-calc div.outer-btn div.inner-btn, .wrapper-calc .topbar div.delete {
    padding: 0;
  }
  .wrapper-calc div.outer-btn div.inner-btn button.btn, .wrapper-calc .topbar div.delete button.btn {
    height: 100%;
    background: #FAFBFC;
    border: solid 1px #D8E2E7;
    border-right: none;
    border-bottom: none;
    border-radius: 0;
    outline: none;
    font-size: 28px;
    color: #000;
  }
  .wrapper-calc div.outer-btn div.inner-btn button.btn:disabled {
    color: #d4d5d5;
  }
  .wrapper-calc div.outer-btn:last-of-type div.inner-btn button.btn {
    border-bottom: solid 1px #D8E2E7;
  }
  .wrapper-calc div.outer-btn div.inner-btn:last-of-type button.btn, .wrapper-calc .topbar div.delete button.btn {
    border-right: solid 1px #D8E2E7;
  }
  .wrapper-calc .topbar div.delete button.btn {
    font-size: 34px;
    position: relative;
    top: 2px;
  }
  .wrapper-calc div.outer-btn div.inner-btn button.btn:active,
  .wrapper-calc div.outer-btn div.inner-btn button.btn.active,
  .wrapper-calc div.topbar div.delete button.btn:active,
  .wrapper-calc div.topbar div.delete button.btn.active
   {
    background: #ddd;
  }
  .default-number {
    background: #000;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/common/Calculator.vue